export const findEnvAttr = (attr: string): any => {
	return process.env[attr];
};
